export default "__VITE_ASSET__BHiOmJg9__"